import { GetAppSettings } from './AppSettings';
import { apimCall } from './helpers/api';

export default async () => {
  const appSettings = GetAppSettings();
  if (process.env.NODE_ENV !== 'production' || appSettings?.RoutingEnvironment === '' || !appSettings?.Routes) {
    return;
  }

  for (const [key, route] of Object.entries(appSettings.Routes)) {
    if (!route) {
      continue;
    }

    try {
      console.log(`Warming up ${route}`);
      await apimCall(key, '/warmup', 'GET');
    } catch (ex) {
      console.log(ex);
    }
  }
};
